import axios from 'axios';
import { getToken } from './auth';
import { getSelectedCompanyId } from '../utils/selectedCompany';

const API = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const listeners = new Set();
export const subscribePricingRequests = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
const emit = (event) => listeners.forEach((listener) => listener(event));
export const listPricingActivities = async () => (await axios.get(`${API}/pricing-activities`, {
  headers: { Authorization: `Bearer ${getToken()}` }, withCredentials: true,
})).data.activities;

export const trackedPricingRequest = (config) => {
  if (!['post', 'patch', 'put', 'delete'].includes(String(config.method).toLowerCase())) return null;
  let path;
  try {
    const url = new URL(config.url, API);
    if (url.origin !== new URL(API).origin) return null;
    path = url.pathname;
  } catch { return null; }
  const branchId = path.match(/^\/branch\/(\d+)\//)?.[1];
  if (/^\/bulk-pricing-operations\/[^/]+\/resume$/.test(path)) return { branchId: null, companyId: Number(getSelectedCompanyId()), kind: 'price-list' };
  if (!branchId) return null;
  const priceList = /\/product\/price-list\/formats\/(?:bulk|recalculate|locks|\d+\/(?:quick|settings|completion|cost-override\/apply))$/.test(path);
  const stock = /\/stock-list\/(?:stock(?:\/\d+(?:\/format)?)?|expense(?:\/\d+)?|import\/conversions(?:\/\d+)?|\d+\/(?:finalize|activation\/run|activation-schedule|price-recommendations\/run))$/.test(path);
  const promotions = /\/product\/price-list\/promotions\/bulk$/.test(path);
  if (!priceList && !stock && !promotions) return null;
  return { branchId: Number(branchId), companyId: Number(getSelectedCompanyId()), kind: priceList || promotions ? 'price-list' : 'stock-cost' };
};

let installed = false;
export const installPricingActivityTracking = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    const scope = trackedPricingRequest(config);
    if (!scope) return config;
    const id = crypto.randomUUID();
    config.headers = { ...config.headers, 'X-Pricing-Activity-Id': id };
    config.pricingActivity = { ...scope, id, status: 'running', stage: 'preparing', createdAt: new Date().toISOString() };
    emit({ activity: config.pricingActivity });
    return config;
  });
  axios.interceptors.response.use((response) => {
    if (response.config?.pricingActivity) emit({ activity: response.data?.pricingActivity || { ...response.config.pricingActivity, status: 'completed' } });
    return response;
  }, (error) => {
    if (error.config?.pricingActivity) emit({ activity: error.response?.data?.pricingActivity || {
      ...error.config.pricingActivity,
      status: error.response ? 'failed' : 'recovering',
      error: error.response?.data?.message || 'Reconectando con la operación…',
    } });
    return Promise.reject(error);
  });
};
